import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { media } from 'styles/breakpoints';

const StyledNavLink = styled(NavLink)`
  font-family: 'Lato', sans-serif;
  font-size: 15px;
  text-decoration: none;
  margin: 0 15px;
  color: #333;

  &:hover {
    color: #d33339;
  }

  ${media.small`
    font-size: 20px;
  `};
`;

export default function NavItem({ children, onClick, to }) {
  return (
    <StyledNavLink
      activeStyle={{
        color: '#CE3438'
      }}
      onClick={() => onClick({ buttonName: children, path: to })}
      exact={true}
      to={to}
    >
      {children}
    </StyledNavLink>
  );
}



// WEBPACK FOOTER //
// ./src/components/NavBar/NavItem.js